import firebase from "firebase";
import {toNumericId} from "@/api/utils";
import store from '@/store/index'
export default {
    async claim(jobId, lineItems, vendor, orderId, deliveryItemId) {
        const db = firebase.firestore()
        await db.collection('jobs').doc(jobId).set(
            {
                lineItems: lineItems,
                deliveryItemId: deliveryItemId,
                orderId: orderId,
                vendor: vendor,
                uid: store.state.user.user.uid,
                createdAt: firebase.firestore.Timestamp.fromDate( new Date())
            }
        )
    },
    async cancel(lineItemId) {
        const numericId = toNumericId(lineItemId)
        const db = firebase.firestore()
        await db.collection('jobs').doc(numericId).delete()
    },
    async isClaimed(lineItemId) {
        const db = firebase.firestore()
        const numericId = toNumericId(lineItemId)
        return (await db.collection('jobs').doc(numericId).get()).exists
    },
    async isMine(lineItemId) {
        const db = firebase.firestore()
        const numericId = toNumericId(lineItemId)
        const job = await db.collection('jobs').doc(numericId).get()
        return job.get('uid') === store.state.user.user.uid
    },
    addListener(lineItemId, callback) {
        const db = firebase.firestore()
        const numericId = toNumericId(lineItemId)
        db.collection('jobs').doc(numericId).onSnapshot(callback)
    }
}